import { render, staticRenderFns } from "./tradeCenter.vue?vue&type=template&id=559cac1a&"
import script from "./tradeCenter.vue?vue&type=script&lang=js&"
export * from "./tradeCenter.vue?vue&type=script&lang=js&"
import style0 from "./tradeCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports